/**
 * Guest welcome interstitial is disabled for AdSense/crawl quality: a full-screen
 * modal on first paint hides homepage content. Guests still pick a society via
 * JoinSocietySection / society search on the home page.
 */
export const shouldShowGuestWelcome = () => false;
